"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var operators_1 = require("rxjs/operators");
var overview_aggregate_config_model_1 = require("../../../../common/model/overview-aggregate-config.model");
var overview_custom_component_provider_service_1 = require("../../../../../../shared/services/api/summary-pages/custom-component/overview-custom-component-provider.service");
var portfolio_definition_custom_values_service_1 = require("../../../../../../shared/services/api/portfolio-definition-custom-values.service");
/**
 * Dialog for selecting custom component.
 */
var OverviewCustomComponentDialogComponent = /** @class */ (function () {
    function OverviewCustomComponentDialogComponent(dialogRef, overviewCustomComponentProviderService, portfolioDefinitionCustomValuesService, data) {
        this.dialogRef = dialogRef;
        this.overviewCustomComponentProviderService = overviewCustomComponentProviderService;
        this.portfolioDefinitionCustomValuesService = portfolioDefinitionCustomValuesService;
        this.data = data;
        this.isValidComponent = true;
        this.aggregateConfig = new overview_aggregate_config_model_1.OverviewAggregateConfigModel();
        this.category = data.category;
        this.rootCategory = data.rootCategory;
        this.selectedFieldName = data.selectedFieldName;
        this.isPortfolioField = data.isPortfolioField;
    }
    OverviewCustomComponentDialogComponent.getDialogConfig = function () {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '400px';
        return dialogConfig;
    };
    OverviewCustomComponentDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.overviewCustomComponents$ = this.isPortfolioField ?
            this.portfolioDefinitionCustomValuesService.getCustomComponents(this.category, this.rootCategory)
            :
                this.overviewCustomComponentProviderService.getCustomComponents(this.category, this.rootCategory, null);
        this.overviewCustomComponents$ = this.overviewCustomComponents$.pipe(operators_1.tap(function (properties) {
            var standardInput = { entity: null, category: _this.category };
            properties.forEach(function (field) { return field.componentInputs = __assign({}, field.componentInputs, standardInput); });
            _this.overviewCustomComponents = properties;
            _this.setSelectedComponentProperties();
        }));
    };
    OverviewCustomComponentDialogComponent.prototype.changeSelectedFieldName = function (value) {
        this.selectedFieldName = value;
        this.setSelectedComponentProperties();
    };
    OverviewCustomComponentDialogComponent.prototype.setSelectedComponentProperties = function () {
        var _this = this;
        this.selectedComponentProperties = this.selectedFieldName &&
            this.overviewCustomComponents.find(function (cmp) { return cmp.componentSelector === _this.selectedFieldName; }) || null;
    };
    OverviewCustomComponentDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    OverviewCustomComponentDialogComponent.prototype.save = function () {
        this.dialogRef.close(this.selectedFieldName);
    };
    OverviewCustomComponentDialogComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-overview-custom-component-dialog',
            styles: [require('./overview-custom-component-dialog.component.css')],
            template: require('./overview-custom-component-dialog.component.html'),
        }),
        __param(3, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef,
            overview_custom_component_provider_service_1.OverviewCustomComponentProviderService,
            portfolio_definition_custom_values_service_1.PortfolioDefinitionCustomValuesService, Object])
    ], OverviewCustomComponentDialogComponent);
    return OverviewCustomComponentDialogComponent;
}());
exports.OverviewCustomComponentDialogComponent = OverviewCustomComponentDialogComponent;
//# sourceMappingURL=overview-custom-component-dialog.component.js.map